import { render, staticRenderFns } from "./BotaoInativarAnexo.vue?vue&type=template&id=535a9625&scoped=true"
import script from "./BotaoInativarAnexo.vue?vue&type=script&lang=js"
export * from "./BotaoInativarAnexo.vue?vue&type=script&lang=js"
import style0 from "./BotaoInativarAnexo.vue?vue&type=style&index=0&id=535a9625&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a9625",
  null
  
)

export default component.exports